/*
  The notification store is intended to be used with local notifications
  Notifications coming from /flash-messages or /toaster/next are handled elsewhere
*/

import mutationTypes from './mutationTypes'
import actionTypes from './actionTypes'
import getterTypes from './getterTypes'
import { Notification } from '@/types'

interface NotificationState {
  notifications: Notification[]
}

const rootState: NotificationState = {
  notifications: [],
}

const mutations = {
  [mutationTypes.ADD.VALUE]: (
    state: NotificationState,
    notif: Notification
  ) => {
    state.notifications.push(notif)
  },
  [mutationTypes.REMOVE.VALUE]: (
    state: NotificationState,
    notif: Notification
  ) => {
    state.notifications = state.notifications.filter(n => n.name !== notif.name)
  },
  [mutationTypes.SET_NOTIFICATIONS.VALUE]: (
    state: NotificationState,
    notifications: Notification[]
  ) => {
    state.notifications = notifications
  },
}

const actions = {}

const getters = {
  [getterTypes.NEXT.VALUE]: (state: NotificationState) => {
    return state.notifications.length ? state.notifications[0] : null
  },
}

export default {
  namespaced: true,
  state: rootState,
  mutations,
  actions,
  getters,
}
